import { LoginService } from './../../../core/services/login.service';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { Filter } from 'src/app/core/models/filter';
import { pluck } from 'rxjs/operators';

const getDentalSupplierAddressesSubscription = gql`query dental_supplier_addresses( $search: String,$status: String, $limit: Int, $offset: Int) {
  dental_supplier_addresses(where: { short_name: {_ilike: $search}}, limit: $limit, offset: $offset) {
    id
    created_at
    updated_at
    dental_supplier_id
    short_name
    line_1
    line_2
    landmark
    city
    state
    country
    postal_code
    latitude
    longitude
    google_place_id
    make_default
    type
    other_type_name
  }
}`;

const getDentalSupplierAddressesAggregateSubscription = gql`query dental_supplier_addresses_aggregate ($search: String, $status: String){
  dental_supplier_addresses_aggregate(where:{short_name: {_ilike: $search}}) {
    aggregate {
      count
    }
  }
}`;

const getDentalProfessionialAddressesSubscription = gql`query dental_professional_addresses( $search: String,$status: String, $limit: Int, $offset: Int) {
  dental_professional_addresses(where: { short_name: {_ilike: $search}}, limit: $limit, offset: $offset) {
    id
    created_at
    updated_at
    dental_professional_id
    short_name
    line_1
    line_2
    landmark
    city
    state
    country
    postal_code
    latitude
    longitude
    google_place_id
    make_default
    type
    other_type_name
  }
}`;

const getDentalProfessionalAddressesAggregateSubscription = gql`query dental_professional_addresses_aggregate ($search: String, $status: String){
  dental_professional_addresses_aggregate(where:{short_name: {_ilike: $search}}) {
    aggregate {
      count
    }
  }
}`;


const getDentalPracticeAddressesSubscription = gql`query dental_practice_addresses( $search: String,$status: String, $limit: Int, $offset: Int) {
  dental_practice_addresses(where: { short_name: {_ilike: $search}}, limit: $limit, offset: $offset) {
    id
    created_at
    updated_at
    dental_practice_id
    short_name
    line_1
    line_2
    landmark
    city
    state
    country
    postal_code
    latitude
    longitude
    google_place_id
    make_default
    type
    other_type_name
  }
}`;

const getDentalPracticeAddressesAggregateSubscription = gql`query dental_practice_addresses_aggregate ($search: String, $status: String){
  dental_practice_addresses_aggregate(where:{short_name: {_ilike: $search}}) {
    aggregate {
      count
    }
  }
}`;



@Injectable({
  providedIn: 'root'
})
export class GetDentalSupplierAddressesService {

  constructor(private apollo: Apollo, private loginService: LoginService) { }

  getDentalSupplierAddresses(filter: Filter){
    const loginData = this.loginService.getLoginData();

    if(loginData.type === 'SUPPLIER'){
      return combineLatest([
        this.apollo.use('external').query({
         query: getDentalSupplierAddressesSubscription,
         fetchPolicy: "network-only",
         variables: {
           search: `%${filter.search}%`,
           limit: filter.limit,
           offset: filter.offset
         }
        }).pipe(pluck('data', 'dental_supplier_addresses')),
        this.apollo.use('external').query({
          query: getDentalSupplierAddressesAggregateSubscription,
          fetchPolicy: "network-only",
          variables: {
            search: `%${filter.search}%`
          }
        }).pipe(pluck('data', 'dental_supplier_addresses_aggregate', 'aggregate', 'count'))
      ]);

    } else if(loginData.type === 'PROFESSIONAL'){
      return combineLatest([
        this.apollo.use('external').query({
         query: getDentalProfessionialAddressesSubscription,
         fetchPolicy: "network-only",
         variables: {
           search: `%${filter.search}%`,
           limit: filter.limit,
           offset: filter.offset
         }
        }).pipe(pluck('data', 'dental_professional_addresses')),
        this.apollo.use('external').query({
          query: getDentalProfessionalAddressesAggregateSubscription,
          fetchPolicy: "network-only",
          variables: {
            search: `%${filter.search}%`
          }
        }).pipe(pluck('data', 'dental_professional_addresses_aggregate', 'aggregate', 'count'))
      ]);

    } else {
      return combineLatest([
        this.apollo.use('external').query({
         query: getDentalPracticeAddressesSubscription,
         fetchPolicy: "network-only",
         variables: {
           search: `%${filter.search}%`,
           limit: filter.limit,
           offset: filter.offset
         }
        }).pipe(pluck('data', 'dental_practice_addresses')),
        this.apollo.use('external').query({
          query: getDentalPracticeAddressesAggregateSubscription,
          fetchPolicy: "network-only",
          variables: {
            search: `%${filter.search}%`
          }
        }).pipe(pluck('data', 'dental_practice_addresses_aggregate', 'aggregate', 'count'))
      ]);
    }
  }
}

